import { Observable } from 'rxjs';

import { InjectionToken } from '@angular/core';

export const REFRESH_TOKEN_CALLER = new InjectionToken<() => Observable<string | null>>('Refresh Token API Call');
